// extracted by mini-css-extract-plugin
module.exports = {"modalShipmentAddress":"ShipmentAddressSelector_modalShipmentAddress__3aEfh","modalAddressContainer":"ShipmentAddressSelector_modalAddressContainer__1FvWU"};